import { Pick_A, Pick_AA } from "../../fixtures/utilityFixtures";
import {
	ICommonInfo,
	IComponentInfo,
	TComponentName,
	TDateTimeMode,
} from "../../types";

export type TColumnType =
	| "OPERATOR"
	| "NO_OPERATOR"
	| "OPERATOR_PREFIX"
	| "HEADER"
	| "NORMAL";

export type TOperator = "ADDITION" | "SUBSTRACTION" | "EQUAL_TO";

export type TDataListComponentType = "production_overview";

export type TValue = string | number;
export const metricDefsData = {
	header: "First Time Through",
	subHeader: "Total no. of FTT garments",
	definition:
		"Total number of garment pieces that are approved at the end-line QC at the first attempt",
};
export const defaultOption = {
	args: {
		options: {
			title: "",
			type: "production_overview" as TDataListComponentType,
			operators: false,
			bg_class: "bg7",
			columns: [
				{
					name: "FTT",
					prop: "ftt",
					sub: false,
					indicator: false,
					threshold_type: "",
					threshold: 0,
					compared_attribute: "",
					subheading: "",
					subheading2: "",
					dynamic_sub_name: false,
					upper_threshold_color: "",
					lower_threshold_color: "",
					dynamic_attribute1: "",
					dynamic_attribute2: "",
					past_visibility: false,
					col_visibility: "",
					modification: true,
					daily_view: "NORMAL" as TColumnType,
					standard_view: "NORMAL" as TColumnType,
					sign: "EQUAL_TO" as TOperator,
					metric_definition: { ...metricDefsData },
					suffixProp: ""
				},
			],
		},
	},
	name: "mo-wgt-customized-data-list",
	data_attribute_name: "model",
	data_model_type: "WebSocketDataModel",
	data_model_args: {
		req_id: "quick_statistics_trend_wip_request_v2",
		req_args: [
			{ key: "@ds", value: "ds5_analytics" },
			{ key: "@subject_splitter", value: 6 },
			{ key: "@time_block1", value: "@time_block1" },
			{ key: "@time_block2", value: "@time_block2" },
			{ key: "@checked_pcs", value: "checked_pcs_m1" },
			{ key: "@granularity", value: "all" },
			{ key: "@plan_name", value: "production_plan" },
			{ key: "@wip_type", value: ["sewing_line"] },
			{ key: "@start_date", value: "2021-04-08" },
			{ key: "@end_date", value: "2021-04-08" },
			{ key: "@subject_key", value: "ind-pemp-p122" },
			{ key: "@display_name", value: "tenant_id" },
			{ key: "@session_dates", value: "2021-04-08" },
			{ key: "@time_block", value: "sessionDate" },
			{ key: "@subjects_filter", value: "regex" },
			{
				key: "@subjects",
				value: "ind-pemp-p122-plant1-floor.*-sewing-.*",
			},
			{ key: "@display_name_filter", value: true },
			{
				key: "@window",
				value: "2021-04-08T00:00:00.000Z/2021-04-08T23:59:59.999Z",
			},
		],
	},
};
export type TSummaryCardConfig = typeof defaultOption;

export type TOptions = Pick_AA<TSummaryCardConfig, "args", "options">;

export type TColumn = Pick_A<TOptions, "columns">[number];

export interface ITileProps {
	key: string;
	column: TColumn;
	data: object;
	dynamicallyComparedKey: TValue;
	timeMode: TDateTimeMode;
}

export interface ISummaryCardProps {
	componentInfo: ISummaryComponentInfo;
	timeMode: TDateTimeMode;
}

export interface ISummaryComponentInfo {
	id: string;
	type: "MO-WGT-CUSTOMIZED-DATA-LIST";
	config: TSummaryCardConfig;
	data: TSummaryCardData;
}

const summaryCardData = {
	data: [{}],
};

export type TSummaryCardData = typeof summaryCardData;

export const testComponentData: object = {
	data: [
		{
			planned_target: 0,
			rtt: 0,
			actual_production: 0,
			trend: 0,
			trend_threshold: 0,
			wip: 0,
			production_hour: "10 of 10",
		},
	],
};
